import { useMemo, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
    createQueryString,
    queryStringToObject,
} from '../utility/helpers/serializeQuery';

function useQueryParams(options = {}) {
    const { search } = useLocation();
    const history = useHistory();

    const queryParams = useMemo(
        () => queryStringToObject(search, options),
        [search, options],
    );

    const setQueryParams = useCallback(
        (queryObj, merge = true) => {
            const newQuery = merge ? { ...queryParams, ...queryObj } : queryObj;
            history.push({ search: createQueryString(newQuery) });
        },
        [history, queryParams],
    );

    const replaceQueryParams = useCallback(
        (queryObj, merge = true) => {
            const newQuery = merge ? { ...queryParams, ...queryObj } : queryObj;
            history.replace({ search: createQueryString(newQuery) });
        },
        [history, queryParams],
    );

    return { queryParams, setQueryParams, replaceQueryParams };
}

export default useQueryParams;
